<template>
    <v-container fluid>
        <v-row>
            <v-col
                cols="12"
            >
                <v-alert
                    color="light-blue darken-4"
                    dark
                    icon="mdi-account"
                    border="top"
                    prominent
                >
                    <v-row align="center">
                        <v-col class="grow text-h4">Payment History</v-col>
                    </v-row>
                </v-alert>
            </v-col>

            <template v-for="(transaction, i) in transactions.filter(x => parseFloat(x.total) > 0)">
                <v-col
                    :key="uniqueid(`transaction-${i}_`)"
                    cols="12"
                    lg="4"
                    md="6"
                    v-if="transaction.office_code && transaction.office_code.toString() == 'BPLO'"
                >
                    <v-card
                        elevation="6"
                    >
                        <v-card-text>
                            <v-card-title>
                                {{ transaction.name }} ({{ transaction.ControlNumber }})
                            </v-card-title>
                            <v-card-subtitle>
                                <p class="mx-0 px-0 py-0 my-0">
                                    {{ transaction.description }}
                                </p>
                                <p class="mx-0 px-0 py-0 my-0">
                                    &#8369;{{ transaction.total }}
                                </p>
                                <p class="mx-0 px-0 py-0 my-0" v-if="IsValidDate(transaction.expirationdate)">
                                    Expiration Date: {{ ExpirationDate(transaction.expirationdate) }}
                                </p>
                            </v-card-subtitle>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                text
                                @click="BPLOPayment(transaction.ControlNumber)"
                            >
                                Pay Now
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>

                <v-col
                    :key="uniqueid(`transaction-${i}_`)"
                    cols="12"
                    lg="4"
                    md="6"
                    v-else
                >
                    <v-card
                        elevation="6"
                    >
                        <v-card-text>
                            <v-card-title>
                                {{ transaction.service_code }} ({{ transaction.txn_number }})
                            </v-card-title>
                            <v-card-subtitle>
                                <p class="mx-0 px-0 py-0 my-0">
                                    {{ transaction.description }}
                                </p>
                                <p class="mx-0 px-0 py-0 my-0">
                                    &#8369;{{ transaction.total }}
                                </p>
                                <p class="mx-0 px-0 py-0 my-0" v-if="IsValidDate(transaction.expirationdate)">
                                    Expiration Date: {{ ExpirationDate(transaction.expirationdate) }}
                                </p>
                            </v-card-subtitle>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                text
                                @click="CHISSPayment(transaction.txn_number)"
                            >
                                Pay Now
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </template>
        </v-row>
    </v-container>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import moment from "moment"

export default {
    name: 'listofalltransactions',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - Payment Transactions',
    },
    data() {
        return {
            citizen: {},
            transactions: [],
        }
    },
    methods: {
        CHISSPayment(txn_number) {
            this.$router.push({
                name: 'chisspayment',
                params: {
                    txn_number,
                }
            })
        },
        IsValidDate(ep) {
            console.log(ep)

            return ep && moment(ep).isValid()
        },
        ExpirationDate(ep) {
            return moment(ep).format('MM/DD/YYYY')
        },
        BPLOPayment(controlnumber) {
            this.$router.push({
                name: 'bplopaymentwithcontrolnumber',
                params: {
                    controlnumber,
                }
            }).catch(() => {})
        },
        uniqueid(prefix = '') {
            return _.uniqueId(prefix)
        },
        alltransactions() {
            axios({
                method: 'post',
                url: `${this.domain}/TreasuryGetAllTransactions`,
                data: {
                    uid: this.citizen._id.toString(),
                }
            })
                .then(response => {
                    // console.log(response.data)
                    if(response.data.response){
                        const transactions = this.$jwt.decode(response.data.transactions, this.jwtsecret)

                        this.transactions = JSON.parse(transactions.transactions)

                        // console.log(transactions)

                        this.transactions.sort((a, b) => {
                            return parseInt(moment(a.expirationdate).unix()) > parseInt(moment(b.expirationdate).unix()) ? 1 : -1
                        })

                        // console.log(this.transactions)
                    }
                })
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        this.alltransactions()
    },
    beforeDestroy() {

    }
}
</script>